export const COLOR_OPTIONS = [
  { value: "bg-violet-100 text-violet-800 border-violet-200", hex: "#8B5CF6", label: "Violeta" },
  { value: "bg-sky-100 text-sky-800 border-sky-200", hex: "#38BDF8", label: "Cielo" },
  { value: "bg-orange-100 text-orange-800 border-orange-200", hex: "#F97316", label: "Naranja" },
  { value: "bg-amber-100 text-amber-800 border-amber-200", hex: "#F59E0B", label: "Ámbar" },
  { value: "bg-emerald-100 text-emerald-800 border-emerald-200", hex: "#10B981", label: "Verde" },
  { value: "bg-rose-100 text-rose-800 border-rose-200", hex: "#F43F5E", label: "Rosa" },
  { value: "bg-teal-100 text-teal-800 border-teal-200", hex: "#14B8A6", label: "Teal" },
  { value: "bg-indigo-100 text-indigo-800 border-indigo-200", hex: "#6366F1", label: "Índigo" },
  { value: "bg-slate-100 text-slate-800 border-slate-200", hex: "#64748B", label: "Gris" },
];

export const MONTHS = [
  { value: "1", label: "Enero" }, { value: "2", label: "Febrero" }, { value: "3", label: "Marzo" },
  { value: "4", label: "Abril" }, { value: "5", label: "Mayo" }, { value: "6", label: "Junio" },
  { value: "7", label: "Julio" }, { value: "8", label: "Agosto" }, { value: "9", label: "Septiembre" },
  { value: "10", label: "Octubre" }, { value: "11", label: "Noviembre" }, { value: "12", label: "Diciembre" }
];
